<template>
  <div class="need-question">
    <div v-if="inputValueType === 'metric' || inputValueType === 'segment'" class="w-100">
        <multiselect
          v-model="values"
          :options="options"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :max-height="250"
          select-label=""
          deselect-label=""
          selected-label=""
          :name="inputQuestionId"
          placeholder="Select"
          label="name"
          track-by="value"
          :preselect-first="false"
          @close="saveValues"
          @select="addValue"
          @remove="removeValue"
        >
            <template #selection="{ values, isOpen }">
              <span class="multiselect__single"
                    v-if="values.length >= 2"
                    v-show="!isOpen">{{ values.length }} selected </span>
            </template>            
            <template #option="props">
              <span class="checkbox-label"  @click.self="select(props.option)">
                <input name="multi-stick-by-option" class="mr-1" type="checkbox" v-model="props.option.checked" @focus.prevent />
                {{ props.option.name }}
              </span>
            </template>        
        </multiselect>
      
    </div>
    <div v-else class="col-6">
      <select :id="inputQuestionId" :name="inputQuestionId" class="custom-select" v-model="value" @change="saveNeedQuestion(value)">
          <option value="0"></option>
          <option v-for="(option, indexName) in inputOptions" v-bind:value="option.value" v-bind:key="indexName">
          {{ option.name }}
          </option>
      </select>      
    </div>
  </div>
</template>

<script>
import NeedQuestionService from "../services/need.question.service";
import AdminService from "../services/admin.service";
import Multiselect from "vue-multiselect";

export default {
  name: "NeedQuestion",
  components: {
    Multiselect
  },
  props: {
    inputOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },   
    inputSavedOptions: {
      type: Array,
      default: function() {
        return [];
      }
    },   
    inputQuestionId: {
      type: Number,
      default: 0
    },
    inputValueType: {
      type: String,
      default: ""
    }

  },
  data() {
    return {
      // Define your component data here
      values: [],
      previousValues: [],
      options: [],
      value: ""
    };
  },
  mounted() {
    this.loadOptions();
    this.previousValues = JSON.parse(JSON.stringify(this.values));
  },
  methods: {
    loadOptions: function() {
      this.options = [];
      this.inputOptions.forEach(option => {
        const isSaved = this.inputSavedOptions.some(savedOption => savedOption.value === option.value && savedOption.questionId === this.inputQuestionId);
        this.options.push({ name: option.name, value: option.value, questionId: this.inputQuestionId, checked: isSaved });
      });
      this.values = this.options.filter(option => option.checked);
    },
    addValue: function(selection) {
      selection.checked = true;
      this.saveValues
    },
    removeValue: function(selection) {
      selection.checked = false;
      this.saveValues();
    },
    saveValues() {
      const currentValues = JSON.stringify(this.values);
      if (currentValues !== this.previousValues && (this.values.length > 0 || this.previousValues.length > 0)) {
        this.previousValues = currentValues;      
        if (this.inputValueType === "metric") {
          NeedQuestionService.saveMetricGroups({ values: this.values, questionId: this.inputQuestionId }, this.saveMetricGroupsCallback, this);
        } else if (this.inputValueType === "segment") {
          NeedQuestionService.saveSegments({ values: this.values, questionId: this.inputQuestionId }, this.saveSegmentsCallback, this);
        }
      }
    },
    // Define your methods here
    saveNeedQuestion(value, callback){},
    saveMetricGroupsCallback(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        AdminService.displaySuccessMessage({ text: response.data.message });
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    saveSegmentsCallback(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        AdminService.displaySuccessMessage({ text: response.data.message });
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    saveNeedQuestionCallback(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        AdminService.displaySuccessMessage({ text: response.data.message });
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    }
  }
};
</script>
